module.exports = __webpack_public_path__ + "static/media/GoBeRobotFront.c6b4acdf.jpg";